import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Heading } from "./NKDaily";
import { Power, Warning } from "@phosphor-icons/react";

const MODES = [
  { key: "daily", label: "NK Daily" },
  { key: "ladder", label: "NK Ladder" },
  { key: "duel", label: "NK Duel" },
  { key: "survival", label: "NK Survival" },
  { key: "saturday", label: "Saturday Challenge" },
  { key: "championship", label: "International Championship" },
];

export default function ModesStatus() {
  const [status, setStatus] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/modes/status"); setStatus(data); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  useEffect(() => { load(); }, []);

  const toggle = async (mode, enabled) => {
    let reason = null;
    if (!enabled) {
      reason = prompt(`Disable ${mode}? Players will see this reason on the home screen:`,
                      "Temporary downtime — back shortly.");
      if (reason === null) return; // cancelled
    }
    try {
      await api.post(`/modes/admin/${mode}/toggle`, { enabled, reason });
      toast.success(enabled ? "Mode enabled" : "Mode disabled");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6">
      <Heading title="Mode availability"
               subtitle="Take any game mode off the main menu temporarily. Players see your reason on their Home screen." />
      {!status ? <p className="text-sm text-nk-mute">Loading…</p> : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {MODES.map((m) => {
            const s = status[m.key] || { enabled: true };
            return (
              <div key={m.key} className={`nk-card p-4 ${!s.enabled ? "border-l-2 border-nk-bad" : ""}`}>
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="eyebrow">{s.enabled ? "Live" : "Disabled"}</p>
                    <p className="font-display text-xl">{m.label}</p>
                    {!s.enabled && s.reason && (
                      <p className="text-xs text-nk-bad mt-2 flex items-start gap-1.5">
                        <Warning size={12} weight="fill" className="mt-0.5 shrink-0" />
                        {s.reason}
                      </p>
                    )}
                  </div>
                  <button onClick={() => toggle(m.key, !s.enabled)}
                          data-testid={`modes-toggle-${m.key}`}
                          className={`px-3 py-1.5 text-xs font-medium rounded-sm inline-flex items-center gap-1.5 ${
                            s.enabled
                              ? "border border-nk-bad text-nk-bad hover:bg-nk-bad/10"
                              : "bg-nk-accent text-nk-bg"
                          }`}>
                    <Power size={11} weight="bold" />
                    {s.enabled ? "Disable" : "Enable"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
